import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import General from './General';
import { getGeneral } from "../../functions/general"
import CircularProgress from '@material-ui/core/CircularProgress';
const useStyles = makeStyles(theme => ({

    container: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        width: '1000px',
        "@media (max-width: 770px)": {
            width: "100%",
        },

    }
}));

const ListGeneral = () => {

    const styles = useStyles();

    const [general, setGeneral] = useState([{ _id: "", title: "", image_urls: [], content: "", date: "", author: "", polls: [], comments: [], likes: [], participants_userids: [] }]);
    const [last, setLast] = useState(null);

    useEffect(() => {

        getGeneral(last).then(res => {
            // console.log(res)
            if (general[0]._id === "") {
                setGeneral(res);
            } else {
                setGeneral([...general, ...res])
            }
        }).catch(err => {
            console.log(err)
        })

        return;
    }, [last])

    const onScroll = () => {
        if (window.scrollY + document.documentElement.clientHeight > document.documentElement.scrollHeight - 1) {
            // dispatch(loadingScreen);
            setLast(general[general.length - 1]._id)
            console.log("onScroll")
        }
    };

    useEffect(() => {
        console.log("add scroll")
        window.addEventListener("scroll", onScroll);
        return () => {
            console.log("remove scroll")
            window.removeEventListener("scroll", onScroll);
        };
    });

    return (
        <>
            <div>
                <h2>
                    투표 게시판
                </h2>
            </div>
            <div className={styles.container}>
                {general.length === 1 ? <CircularProgress /> : <>  {
                    general.map((item, index) => {
                        return (
                            <General
                                key={index}
                                _id={item._id}
                                title={item.title}
                                content={item.content}
                                date={item.date}
                                author={item.author}
                                image_urls={item.image_urls}
                                polls={item.polls}
                                comments={item.comments}
                                likes={item.likes}
                                participants_userids={item.participants_userids}
                                done={item.done}
                            />

                        )
                    })
                }</>
                }
            </div>
        </>
    );
};

export default ListGeneral;